export default "__VITE_ASSET__Hv$BCpk5__"